import { formatRelativeFromIso } from '@/lib/misc/Utils'
import { getStatusLevelStyles } from './utils'
import type { StatusReportWithTimeline } from './types'

const StatusReportTimelineCard = ({
  report,
}: {
  report: StatusReportWithTimeline
}) => {
  const summaryStyles = getStatusLevelStyles(report.currentLevel)
  const summaryPillLabel = report.updates[0]?.label ?? summaryStyles.label

  return (
    <div className="group relative overflow-hidden px-3 py-3 transition-colors hover:bg-neutral-05/80">
      <div
        className={`absolute left-0 top-0 h-full w-[3px] rounded-r-sm ${summaryStyles.dotClass}`}
      />

      <div className="min-w-0 pl-1">
        <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
          <p className="text-sm font-semibold text-neutral-60">
            {report.title}
          </p>
          <span
            className={`inline-flex items-center rounded-full px-2 py-0.5 text-sm font-medium ring-1 ring-inset ${summaryStyles.feedBadgeClass}`}
          >
            {summaryPillLabel}
          </span>
        </div>

        <ul className="relative mt-3 ml-0.5 space-y-4 border-l border-neutral-20/80 pl-4">
          {report.updates.map((u) => {
            const uStyles = getStatusLevelStyles(u.level)
            const rel = formatRelativeFromIso(u.date)
            return (
              <li key={u.id} className="relative">
                <span
                  className={`absolute -left-[calc(0.25rem+16px)] top-1.5 h-2.5 w-2.5 rounded-full ring-2 ring-white ${uStyles.dotClass}`}
                  aria-hidden
                />
                <div className="flex flex-wrap items-baseline gap-x-1.5 gap-y-0.5">
                  <span className="text-sm font-semibold text-neutral-60">
                    {u.label}
                  </span>
                  <span className="text-sm text-neutral-40" aria-hidden>
                    &middot;
                  </span>
                  <time
                    className="text-sm tabular-nums text-neutral-40"
                    dateTime={u.date}
                  >
                    {new Date(u.date).toLocaleString(undefined, {
                      month: 'short',
                      day: 'numeric',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit',
                    })}
                  </time>
                  {rel && (
                    <span className="text-sm text-neutral-40">({rel})</span>
                  )}
                </div>
                {u.message ? (
                  <p className="mt-1.5 text-sm leading-relaxed text-neutral-50">
                    {u.message}
                  </p>
                ) : null}
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}

export default StatusReportTimelineCard
